module.exports = __webpack_public_path__ + "static/media/objects_05.64bef697.svg";